var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellIconUnread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 17.5001H11.6667C11.6667 18.4167 10.9167 19.1667 10 19.1667C9.08333 19.1667 8.33333 18.4167 8.33333 17.5001ZM17.5 15.8334V16.6667H2.5V15.8334L4.16667 14.1667V9.16675C4.16667 6.58341 5.83333 4.33341 8.33333 3.58341V3.33341C8.33333 2.41675 9.08333 1.66675 10 1.66675C10.9167 1.66675 11.6667 2.41675 11.6667 3.33341V3.58341C14.1667 4.33341 15.8333 6.58341 15.8333 9.16675V14.1667L17.5 15.8334ZM14.1667 9.16675C14.1667 6.83341 12.3333 5.00008 10 5.00008C7.66667 5.00008 5.83333 6.83341 5.83333 9.16675V15.0001H14.1667V9.16675Z",
    fill: "#4F4F4F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 6.5,
    r: 3,
    fill: "#C7222A",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIconUnread);
export default __webpack_public_path__ + "static/media/notification-bellIcon-unread.3fa2f26349f1d8e84a9d2668cde7621d.svg";
export { ForwardRef as ReactComponent };